// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { EmployerApi } from "../../../util/api/EmployerApi";
import SimpleField from "../../forms/SimpleField";

import Employer from "../../../store/wrappers/Employer";

import BackButton from "../../widgets/BackButton";

import { Alert } from "../../../store/Alert";


export class EmployerForm extends Component {
    static displayName = EmployerForm.name;

    constructor(props) {
        super(props);

        //Assume we're creating a new employer unless the user provided a valid id as a url argument
        let employer = false;
        let displayMode = "new";

        if (this.props.match.params.id) {
            employer = this.props.store.employers.getById(this.props.match.params.id);
            displayMode = "edit";
        }

        this.state = {
            isSubmitting: false,
            employer: employer,
            mode: displayMode
        };

        if (displayMode == "new") {
            this.props.store.updateBanner("Add New");
        }
        else {
            this.props.store.updateBanner("Update Employer", employer.name);
        }

        this.deleteEmployer = this.deleteEmployer.bind(this);
    }


    setInitialValues() {
        let employer = this.state.employer;
        if (!employer) {
            employer = new Employer()
        }

        return {
            id: (employer.id ? employer.id : ""),
            name: (employer.name ? employer.name : ""),
            city: (employer.city ? employer.city : ""),
            state: (employer.state ? employer.state : ""),
            country: (employer.country ? employer.country : ""),
        }
    }

    async handleSubmission(values, setSubmitting, resetForm) {
        this.setState({ setSubmitting: true });

        //If the user creates a new employer, the form doesn't get rerendered. That would be easy!
        if (values.id == "" && this.state.employer.id) {
            values.id = this.state.employer.id;
        }

        let employer = new Employer(values, true);

        employer = await employer.save(this.props.store);

        console.log(employer);
        console.log(employer.errors);
        //If there are now errors and the user is inputting employers. 
        if (this.state.mode == "new" && (employer.errors == null || employer.errors.length == 0)) {
            console.log("added employer")
            resetForm()
            this.setState({ setSubmitting: false });
        }
        else if (this.state.mode == "edit" && (employer.errors == null || employer.errors.length == 0)) {
            console.log("updated employer")
            this.setState({
                employer: employer,
                setSubmitting: false,
                mode: "edit"
            });
        }
    }

    async deleteEmployer(e) {
        if(window.confirm( "Are you sure you'd like to remove this employer from SWS? NOTE: Any associated supervisors will be removed as well." )) {
            const employerId = e.target.value;
            console.log(e)
            try {

                await EmployerApi.delete(employerId);
                
                await this.props.store.getFromApi([ "employers","supervisors"])

                this.props.history.goBack();

                let successAlert = new Alert("Successfully deleted employer!");
            }
            catch (e) {
                let errorAlert = new Alert("Error deleting employer", "Does the employer have an association with an account? If so, it cannot be deleted.");
            }
        }
    }

    validate(values) {
        const errors = {};
        
        return errors;
    }

    render() {
        return (
            <div>
                {this.introText()}
                <div className="row">
                    <div className="col-12 col-md-6">
                        {this.form()}
                    </div>
                </div>
            </div>
        )
    }

    introText() {
        if (this.state.mode == "new") {
            return (
                <React.Fragment>
                    <h1 className="h3">New Employer</h1>
                </React.Fragment>
            )
        }
        return (undefined)
    }

    form() {
        return (
            (this.state.mode === "new" || this.state.employer ? (
                <Formik
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting, resetForm }) => this.handleSubmission(values, setSubmitting, resetForm)}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Field name="id" className="form-control" type="hidden" name="id"/>

                            <SimpleField name="name" />
                            <SimpleField name="city" />
                            <SimpleField name="state" />
                            <SimpleField name="country" />


                            <div className="staffFormSubmitButtons">
                                {this.state.employer &&
                                    <React.Fragment>
                                        <BackButton className="btn btn-secondary mt-2 mr-2" innerText="Cancel" />
                                        <button value={this.props.match.params.id} type="button" onClick={this.deleteEmployer} className="btn btn-secondary mt-2 mr-2">Delete Employer</button>
                                    </React.Fragment>
                                }
                                <button className="btn btn-primary mt-2" type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            ) :
                (
                    <div>
                        <h3>Could not find employer.</h3>
                    </div>
                )
            )
        );
    }
}
